import React from 'react'

import Wrapper from '../../components/Wrapper'

import Slide from './Slide';
import Title from "../../components/Title";

export default (props) => (
  <Wrapper>
    <Slide {...props} />
  </Wrapper>
)